import { useMemo } from 'react';

import { useEntity } from '../../entities/hooks';
import { useImage } from '../../entities/hooks/useImage';
import DefaultProfileIcon from '../../collections/detail/cover/assets/DefaultProfileIcon.png'

const getCoverUrl = (image = {}, version = 2) => {
  if (image.tmpUrl) return image.tmpUrl;
  if (image['image-versions']) return image['image-versions'][version].url;
  if (image['asset-url']) return image['asset-url'];
  return DefaultProfileIcon;
};

const useCollectionCover = (params, version) => {
  const { entity: collection } = useEntity(params);
  const { entity: image } = useEntity(collection['cover-image'] || collection['subject-avatar']);
  const { entity: canvasImage } = useEntity({ type: 'images', id: image?.['canvas-image']?.id });

  return useMemo(() => {
    return getCoverUrl(Object.keys(canvasImage).length > 0 ? canvasImage : image, version);
  }, [image, canvasImage, version]);
};

export const useCollectionCoverImage = ({ id, type, version }) => {
  const { entity: collection } = useEntity({ id, type });
  const imageParams = collection['cover-image'] ||
    collection['subject-avatar'] || { type: 'images ', id: '' };
  return useImage({ version: version || 2, ...imageParams });
};

export default useCollectionCover;
